<template>
  <a-layout style="display: flex; flex-direction: column">
    <a-layout-header class="header">
      <div class="logo-menu" :style="'background-image: url(' + logo + ')'" @click="hrefHome()" v-if="!collapsed"></div>

      <div class="logo-menu" :style="'background-image: url(' + logo2 + '); width: 125px;'" @click="hrefHome()" v-if="collapsed"></div>
      <div style="flex: 1; display: flex; flex-direction: row; justify-content: space-between">
        <span class="name-project">{{ nameProject }}</span>
        <div>
          <a-button @click="logout()" shape="circle" style="float: right; margin-top: 16px; margin-right: 10px">
            <template #icon>
              <em style="color: red" class="fas fa-power-off"></em>
            </template>
          </a-button>
          <span class="data-user">
            <strong>{{ dataUser.nome }}</strong>
            <label>{{ dataUser.cpf }}</label>
          </span>

          <a-tooltip placement="bottomRight">
            <template #title>
              <span>{{ dataUser.nome }} - {{ dataUser.cpf }}</span>
            </template>
            <a-avatar :size="40" class="avatar-user" :src="dataUser.iconUser" />
          </a-tooltip>
        </div>
      </div>
    </a-layout-header>
    <div style="display: flex; flex-direction: row">
      <a-layout-sider id="sider-bar" width="270" v-model:collapsed="collapsed" :collapsed-width="collapsedWidth()" collapsible>
        <a-menu v-model:selectedKeys="selectedKeys" theme="light" mode="inline" @click="closeMenu()">
          <template v-for="menu in menus" :key="menu.path">
            <a-sub-menu :id="menu.uniqueKey" v-if="menu.menu && menu.submenu" :key="menu.path">
              <template #title>
                <span>
                  <em :class="menu.icon"></em>
                  <span class="nav-text">{{ menu.name }}</span>
                </span>
              </template>
              <a-menu-item v-for="subMenu in menu.submenu" :key="subMenu.path">
                <span v-if="!subMenu.repasse">
                  <em :class="subMenu.icon"></em>
                </span>

                <span v-if="subMenu.repasse">
                  <a-badge :count="qtdSolicitaoRepasse" :style="badgeStyle">
                    <em style="color: #00a6ff" class="fa-solid fa-bell"></em>
                  </a-badge>
                </span>

                <router-link class="nav-text" :to="{ path: subMenu.path, force: true }">
                  {{ subMenu.name }}
                </router-link>
              </a-menu-item>
            </a-sub-menu>
            <a-menu-item v-if="menu.menu && !menu.submenu" :key="menu.path" :id="menu.uniqueKey">
              <em :class="menu.icon"></em>
              <router-link class="nav-text" :to="menu.path">
                {{ menu.name }}
              </router-link>
            </a-menu-item>
          </template>
        </a-menu>
      </a-layout-sider>
      <a-layout>
        <a-layout-content style="background-color: white; margin: 0px 15px">
          <div :style="{ padding: '10px', minHeight: '360px' }">
            <a-config-provider :locale="locale">
              <router-view />
            </a-config-provider>
          </div>
        </a-layout-content>

        <a-layout-footer style="text-align: center"> Secretaria de segurança Pública do Estado de Goiás </a-layout-footer>
      </a-layout>
    </div>
  </a-layout>
</template>

<script>
import pt_BR from 'ant-design-vue/lib/locale-provider/pt_BR';
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';

import { logo, logo2, nameProject } from './config/system';
import { getRoutesPermission } from './router/routes';
import { getDataUser, getModuloMenuSelecionado, validarMenus, removerModuloMenuSelecionado, mobileAndTabletCheck } from './utils/index';
import { openNotification, typesNotification } from './utils/notifications';
import { logoutUser } from './utils/sso';
import { getRepasseByCpfProfAndSituacao } from '@/components/service/RepasseAtendimento';

export default defineComponent({
  components: {},
  setup() {
    const router = useRouter();

    const hrefHome = () => {
      if (getModuloMenuSelecionado() != null) {
        router.push({ path: '/home' });
      } else {
        router.push({ path: '/alterar-modulo' });
      }
    };

    const logout = () => {
      openNotification(typesNotification.alert, 'Deslogando usuário...', 10000);
      removerModuloMenuSelecionado();
      logoutUser();
    };

    const closeMenu = () => {
      if (!document.querySelector('.ant-layout-sider-zero-width') && document.querySelector('.ant-layout-sider-zero-width-trigger')) {
        document.querySelector('.logo-menu').setAttribute('style', 'background-image:url(' + logo2 + ')');
        document.querySelector('.ant-layout-sider-zero-width-trigger').click();
        setTimeout(() => {
          document.querySelectorAll('.ant-tooltip.ant-menu-inline-collapsed-tooltip.ant-tooltip-placement-right').forEach((e) => (e.style.display = 'none'));
        }, 500);
      }
    };

    return {
      selectedKeys: ref([]),
      hrefHome,
      logout,
      closeMenu,
    };
  },
  data: function () {
    return {
      locale: pt_BR,
      collapsed: ref(false),
      dataUser: getDataUser(),
      menus: getRoutesPermission(getDataUser()),
      moduloMenuSelecionado: getModuloMenuSelecionado(),
      logo,
      logo2,
      nameProject,
      qtdSolicitaoRepasse: 0,
      badgeStyle: {},
    };
  },
  async created() {
    this.badgeStyle = {
      'min-width': '13px',
      height: '13px',
      'line-height': '13px',
    };
    this.validarMenuSelecionado();
    await this.getSolicitacaoRepasse();
  },
  methods: {
    flatString(funcoes) {
      return funcoes.map((funcao) => funcao.nome).join(', ');
    },

    navigate(route) {
      this.$router.push({ path: route });
      setTimeout(() => (this.selectedKeys[0] = this.$router.currentRoute.value.path));
    },
    collapsedWidth() {
      return mobileAndTabletCheck() ? 0 : 80;
    },
    async getSolicitacaoRepasse() {
      await getRepasseByCpfProfAndSituacao(this.dataUser.cpf).then((r) => {
        this.qtdSolicitaoRepasse = r.data.length;
      });
    },
    validarMenuSelecionado() {
      if (this.moduloMenuSelecionado === undefined) {
        this.$router.push('/alterar-modulo');
      } else {
        setTimeout(() => validarMenus(this.menus, this.moduloMenuSelecionado));
      }
    },
  },
  mounted() {},
  unmounted() {},
  beforeMount() {
    let router = useRouter();

    setTimeout(() => this.selectedKeys.push(router.currentRoute.value.path));

    setTimeout(() => {
      if (document.querySelector('#loading-start')) {
        document.querySelector('#loading-start').remove();
      }
    }, 500);
  },
});
</script>
